export const STATUS_TYPE = {
  '-1': { text: '失败', color: 'danger' },
  0: { text: '提现成功', color: 'success' },
  1: { text: '已提交', color: 'info' },
  2: { text: '已取消', color: 'disabled' },
  3: { text: '确认中', color: 'disabled' },
  4: { text: '已审核', color: '' },
  5: { text: '区块链网络已经发送，等待确认中', color: 'warning' },
  6: { text: '系统异常', color: 'danger' },
  7: { text: '管理员撤销', color: 'disabled' },
  8: { text: '确认中', color: 'disabled' },
};

export const DEPOSIT_STATUS_TYPE = {
  '-1': { text: '失败', color: 'danger' },
  0: { text: '已确认', color: 'success' },
  1: { text: '已提交', color: 'info' },
  2: { text: '已取消', color: 'disabled' },
  3: { text: '确认中', color: 'disabled' },
  4: { text: '已审核', color: '' },
  5: { text: '区块链网络已经发送，等待确认中', color: 'warning' },
  6: { text: '系统异常', color: 'danger' },
  7: { text: '管理员撤销', color: 'disabled' },
  8: { text: '确认中', color: 'disabled' },
};

export const ALL_DEPOSIT_ENSURED = {
  true: { text: '都已确认', color: 'success' },
  false: { text: '有未确认或异常', color: 'danger' }
};
